import { C25LocationInfoProps } from './C25LocationInfo.types';
import { getCheckbox } from 'src/shared/param-utils';
import { CreateLocationDataModel } from 'src/shared/LocationData.service';
import { GetGoogleMapAPI } from 'src/shared/GoogleMap.service';
import { useI18n } from 'next-localization';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { LocationInfoProps } from '@ahc-digital/component-library';

export function CreateLocationInfoModel(
  props?: C25LocationInfoProps,
  googleMapAPIKey?: string
): LocationInfoProps {
  const { fields, params } = props || {};
  const { t } = useI18n() || {};
  const { renderLink } = useConditionalRendering();
  return {
    isMapShowing: !getCheckbox(params?.HideMap),
    showHoursOfOperation: getCheckbox(params?.ShowHoursOfOperation),
    showServicesAvailable: getCheckbox(params?.ShowServicesAvailable),
    location: (fields?.Location?.fields && CreateLocationDataModel(fields.Location)) || {
      locationName: '',
      addressLine1: '',
    },
    googleMapsApiKey: GetGoogleMapAPI(googleMapAPIKey ?? ''),
    directionsLabel: t('LocationInfo-DirectionsLabel'),
    hoursLabel: t('LocationInfo-HoursLabel'),
    servicesAvailableLabel: t('LocationInfo-ServicesAvailableLabel'),
    detailPageLink: renderLink(fields?.Location?.DetailPageLink),
  };
}
